"use strict";

var _defineProperty = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.evaluate = evaluate, Object.defineProperty(exports, "evaluateRaw", {
  enumerable: !0,
  get: function get() {
    return _lib.evaluateRaw;
  }
}), Object.defineProperty(exports, "parse", {
  enumerable: !0,
  get: function get() {
    return _parser.parse;
  }
}), Object.defineProperty(exports, "scan", {
  enumerable: !0,
  get: function get() {
    return _scanner.scan;
  }
}), exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties")),
    _ethers = require("ethers"),
    _helpers = require("./helpers"),
    _lib = require("./lib"),
    _parser = require("./parser"),
    _scanner = require("./scanner");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var source, i = 1; i < arguments.length; i++) {
    source = null == arguments[i] ? {} : arguments[i], i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}
/**
* Evaluate a radspec expression (`source`) for a transaction (`call`)
*
* @example
* import * as radspec from 'radspec'
*
* const expression = 'Will multiply `a` by 7 and return `a * 7`.'
* const call = {
*   abi: ['function multiply(uint256 a) public view returns(uint256)'],
*   transaction: {
*     to: '0x8521742d3f456bd237e312d6e30724960f72517a',
*     data: '0xc6888fa1000000000000000000000000000000000000000000000000000000000000007a'
*   }
* }
*
* radspec.evaluate(expression, call)
*   .then(console.log) // => "Will multiply 122 by 7 and return 854."
* @param {string} source The radspec expression
* @param {Object} call The call that determines the bindings for this evaluation
* @param {Array} call.abi The ABI used to decode the transaction data
* @param {Object} call.transaction The transaction to decode for this evaluation
* @param {string} call.transaction.to The destination address for this transaction
* @param {string} call.transaction.data The transaction data
* @param {?Object} options An options object
* @param {?ethers.providers.Provider} options.provider EIP 1193 provider
* @param {?Object} options.userHelpers User defined helpers
* @return {Promise<string>} The result of the evaluation
*/


function evaluate(source, call) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var _ref$userHelpers = _ref.userHelpers,
      userHelpers = _ref$userHelpers === void 0 ? {} : _ref$userHelpers,
      options = (0, _objectWithoutProperties2.default)(_ref, ["userHelpers"]); // Create ethers interface object

  var ethersInterface = new _ethers.ethers.utils.Interface(call.abi),
      _ethersInterface$pars = ethersInterface.parseTransaction(call.transaction),
      args = _ethersInterface$pars.args,
      functionFragment = _ethersInterface$pars.functionFragment,
      parameters = functionFragment.inputs.reduce(function (parameters, input) {
    return _objectSpread(_defineProperty({}, input.name, {
      type: input.type,
      value: args[input.name]
    }), parameters);
  }, {}),
      availableHelpers = _objectSpread(_objectSpread({}, _helpers.defaultHelpers), userHelpers),
      _call$transaction = call.transaction,
      from = _call$transaction.from,
      to = _call$transaction.to,
      value = _call$transaction.value,
      data = _call$transaction.data; // Parse as an ethers TransactionDescription
  // Evaluate expression with bindings from the transaction data


  return (0, _lib.evaluateRaw)(source, parameters, _objectSpread(_objectSpread({}, options), {}, {
    availableHelpers: availableHelpers,
    from: from,
    to: to,
    value: value,
    data: data
  }));
}

var _default = evaluate;
exports.default = _default;